import React from 'react'
import './index.css'
 const Toast = ({text}) => {
    return (
        <div className={`toast_box ${!!text?"":"nodis"}`}>{text}</div>
    )
}
 export default Toast